const combineNames = (names) => {
	const { fName, mName, lName } = names;

	let nameArray = [fName, mName, lName];
	nameArray = nameArray.filter(Boolean);
	return nameArray.join(' ');
};

export { combineNames };
